// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"676":"209abc9c","962":"7facdf59"}[chunkId] + ".chunk.css";
};